import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Query } from 'react-apollo'

import { SELF_QUERY } from '../../queries'
import { SELECTED_BRANCH } from '../../constants'

import { ChevronThinLeft } from '../Icons'
import BrancheList from '../../containers/BrancheList'
import Error from '../../components/Error/'
import Loader from '../../components/Loader/'
import { Container, Popup, Close, MobileClose } from './styles'

class BranchPopup extends Component {
  handleClick(branch) {
    if (window.localStorage.getItem(SELECTED_BRANCH, branch)) {
      window.localStorage.removeItem(SELECTED_BRANCH, branch)
      window.localStorage.setItem(SELECTED_BRANCH, branch)
    } else {
      window.sessionStorage.removeItem(SELECTED_BRANCH, branch)
      window.sessionStorage.setItem(SELECTED_BRANCH, branch)
    }
    this.props.closePopup()
    this.props.history.push('/')
  }

  handleClickContainer(e) {
    if (document.body.clientWidth > 768) {
      this.props.closePopupContainer(e)
    }
  }

  render() {
    if (!this.props.popupActive) {
      return null
    }
    let selectedBranch = window.localStorage.getItem(SELECTED_BRANCH)
      ? window.localStorage.getItem(SELECTED_BRANCH)
      : window.sessionStorage.getItem(SELECTED_BRANCH)

    return (
      <Query query={SELF_QUERY}>
        {({ loading, error, data }) => {
          if (loading) return <Loader fixed from="0%" to="100%" />
          if (error) return <Error error="uw gebruikersgegevens" />
          const { branches } = data.self
          return (
            <Container className="js-popup-container" onClick={this.handleClickContainer.bind(this)}>
              <Popup>
                <MobileClose onClick={this.props.closePopup}>
                  <ChevronThinLeft size="" />
                  Annuleren
                </MobileClose>
                <BrancheList
                  handleClick={this.handleClick.bind(this)}
                  title="Kies uw filiaal"
                  branches={branches}
                  selectedBranch={selectedBranch}
                  dark
                />
                <Close onClick={this.props.closePopup}>Annuleren</Close>
              </Popup>
            </Container>
          )
        }}
      </Query>
    )
  }
}

export default withRouter(BranchPopup)



// WEBPACK FOOTER //
// ./src/components/BranchPopup/index.js